import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appInputLabel]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppInputLabelDirective {
  #base = '!flex items-center gap-2 !text-gray-700 mb-2 !text-sm';
  class = input<string>();

  public styles = computed(() => {
    return cn(this.#base, this.class());
  });
}
